<ng-container *ngIf="vm$ | async as vm">
  <ng-container *ngIf="vm.zitting">
    <div class="zitting-titel-row">
      <h1 class="zitting-titel-col head1">{{vm.zitting.SoortZitting}} {{vm.zitting.DatumZitting | date:'EEEE d LLLL yyyy'}}</h1>
      <div  class="zitting-notities-col" *ngIf="vm.zitting.IsActiefLid">
        <i role="img" [attr.aria-label]="'Aantal ongelezen notities voor deze zitting :'+ vm.zitting.AantalOngelezenNotities" class="icon-notities icon-notities-middle"></i>
        <div aria-hidden="true" class="zitting-notities-aantal">{{vm.zitting.AantalOngelezenNotities}}</div>
      </div>
    </div>

    <div class="zitting-documenten-row">

      <div class="zitting-return-col" *ngIf="appService.routing.backHistoryItem">
        <button class="btn btn-default"
          (click)="appService.routing.navigateBack()">{{appService.routing.backHistoryItem.title}}</button>
      </div>

      <div class="zitting-documenten-col">
          <a (click)="openDocumentZitting(document)" *ngFor="let document of vm.documenten trackBy:getDocumentZittingId" href="#" [attr.aria-label]="document.Titel"  class="zitting-document-col">
            <i class="icon-file"></i><span class="document-titel">{{document.Titel}}</span>
          </a>
      </div>

      <div class="zitting-mymeetingstatus-col" *ngIf="vm.zitting.IsActiefLid">
        <span class="mymeetingstatus-text">ik woon de zitting{{vm.zitting.IsAfwezig ? ' niet' : ''}} bij</span>
        <button type="button" (click)="toggleMyMeetingStatusSubj.next(vm.zitting.Id)" class="switch" role="switch"
          [attr.aria-checked]="!vm.zitting.IsAfwezig" [ngClass]="vm.zitting.IsAfwezig ? 'active':'inactive'"
          aria-label="ik woon de zitting bij">
        </button>
      </div>
    </div>

    <div class="zitting-button-row">
      <div class="zittingbuttonrow-buttons-container">
        <div class="button-group">
          
            <button tabindex="0" (click)="filter(vm.zitting.Id,nietbesprekenViewState)" class="btn-group-btn"
              [ngClass]="vm.viewState.nietbesprekenClass">alle
              punten</button>
          @if (vm.zitting.StandpuntToegelaten) {              
            <button tabindex="0" (click)="filter(vm.zitting.Id,besprekenViewState)" class="btn-group-btn"
              [ngClass]="vm.viewState.besprekenClass">te
              bespreken punten</button>
          }
          <button (click)="filter(vm.zitting.Id,notitiesViewState)" [ngClass]="vm.viewState.notitiesClass" tabindex="0" class="btn-group-btn">notities</button>
        </div>
      </div>
    </div>
@if (vm.viewState!==notitiesViewState) {
    <div role="list" class="zitting-detail-row">
      <div role="listitem" class="agendapunt-row" *ngFor="let punt of vm.agendapunten trackBy:getAgendapuntId" [id]="'p_'+punt.Id">

        <div *ngFor="let group of punt.Groups">
          <ng-container [ngSwitch]="group.level">
            <h2 class="agendapunt-groep head1" *ngSwitchCase="0">{{group.value}}</h2>
            <h3 class="agendapunt-groep head2" *ngSwitchCase="1">{{group.value}}</h3>
            <h4 class="agendapunt-groep head3" *ngSwitchCase="2">{{group.value}}</h4>
            <h5 class="agendapunt-groep head4" *ngSwitchCase="3">{{group.value}}</h5>
            <h6 class="agendapunt-groep head5" *ngSwitchCase="4">{{group.value}}</h6>
          </ng-container>
        </div>

        <div class="agendapunt-header-row">
          <div class="agendapunt-volgnummer-col c2-clickable head4basesmall" (click)="detailPuntSubj.next(punt)">
              <span class="screen-reader-only">Volgnummer {{punt.Volgnummer}}</span> <span aria-hidden="true">{{punt.Volgnummer}}</span>
          </div>
          <div class="agendapunt-icon-col">
            <i role="img" *ngIf="punt.HeeftSubPunten" title="Punt heeft subpunten" class="icon-lijst"></i>
            <i role="img" *ngIf="punt.HeeftGerelateerdePunten" title="Punt heeft gerelateerde punten"
              class="icon-link"></i>
            <i role="img" *ngIf="punt.AantalGekoppeldeDossiers"
              [title]="'Punt heeft ' + punt.AantalGekoppeldeDossiers+' gekoppelde dossier(s)'"
              class="icon-external-link"></i>
          </div>

          <a href="#" class="agendapunt-titel-col head4basesmall" (click)="detailPunt(vm.zitting.Id, punt.Id,vm.viewState===besprekenViewState)" [ngClass]="{'notactive':vm.currentpunt!=punt}">
            {{punt.Titel}}
          </a>

          <div class="agendapunt-icons-col">
            <button (click)="bepaalStandpuntSubj.next(punt)" class="btn-icon-bold" *ngIf="punt.StandpuntToegelaten && punt.HasCurrentUserStemrecht"
              [ngClass]="{'null':'icon-udecided-circle', '0':'icon-udecided-circle','1':'icon-disagree-circle','2':'icon-agree-circle'}[punt.MijnStandpunt]"
              role="link" title="Standpunt bepalen">
            </button>

            <button role="link" title="Notities" [attr.aria-label]="'Notities, aantal : '+punt.AantalNotities" (click)="nagivateToNotities(punt,vm.viewState === besprekenViewState)" class="btn-icon-bold icon-notities">
              <div aria-hidden="true" class="icon-notities-aantal">{{punt.AantalNotities | zerotoempty}}</div>
            </button>

            <button role="switch" [attr.aria-checked]="punt.BladwijzerId" title="Bladwijzer instellen" (click)="bookmarkAgendapuntSubj.next(punt)" class="btn-icon-bold"
              [ngClass]="punt.BladwijzerId ? 'icon-star-filled': 'icon-star'">
            </button>

            <button role="switch" [attr.aria-checked]="vm.currentpunt==punt" title="Weergave detail punt" (click)="detailPuntSubj.next(punt)" class="btn-icon-bold"
              [ngClass]="vm.currentpunt==punt  ? 'icon-arrow_dwn' :'icon-arrow_up' ">
            </button>

            <app-bepaal-standpunt *ngIf="punt==vm.currentStandpunt" (closeStandpunt)="closeStandpuntHandler()"
              [zittingId]="vm.zitting.Id" [standpunten]="vm.standpunten"></app-bepaal-standpunt>
          </div>
        </div>

        <app-detail-punt [detail]="vm.currentdetailpunt" [punt]="vm.currentpunt" class="detailagendapunt-row"
          *ngIf="vm.currentdetailpunt && vm.currentpunt==punt">
        </app-detail-punt>

      </div>

    </div>
  } @else  {
    
    <div class="cobra-zitting-notities" >
      <button tabindex="0" title="Exporteer naar Excel" class="btn btn-default" type="button" (click)="exportNotities(vm.zitting.Id)">
        <i class="fa fa-file-excel-o"></i>
      </button>
    @for (notitie of vm.notities; track  notitie.NotitieId) {
      
      @if (vm.notities[$index-1]?.PuntId != notitie.PuntId){
        <span  class="notities-agendapunt-titel-col notactive head4">{{notitie.VolgnummerPunt}} {{notitie.TitelPunt}}</span>
      }
      
      <div>
        <i class="fa fa-user-o fa-15"> </i><span>{{notitie.EigenaarNotitie}}</span>
        <span>{{notitie.NotitieInhoud}}</span>
      </div>

    }
    </div>
  
  }
  </ng-container>
</ng-container>